import request from '@/utils/request'
import requestRefresh from '@/utils/requestRefresh'
export function login (data) {
  return request({
    url: '/user/login',
    method: 'post',
    params: data
  })
}
// 刷新token
export function refreshToken () {
  return requestRefresh({
    url: '/token/refresh',
    method: 'put'
  })
}
// 统计
// 毕业总数
export function graduate (data) {
  return request({
    url: '/statistics/graduate',
    method: 'get',
    params: data
  })
}
// 录取总数
export function admit (data) {
  return request({
    url: '/statistics/admit',
    method: 'get',
    params: data
  })
}
// 统计论文综述
export function paper (data) {
  return request({
    url: '/statistics/paper',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js